module.exports = __webpack_public_path__ + "img/Boarded 3.8af708bb.svg";